import React, { useState } from 'react';

import supportIcon from '../../assets/svgs/support.svg';
import classes from './SupportButton.module.scss';

const SupportButton = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`${classes.supportButton} ${hovered ? classes.hovered : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className={classes.text}>Support</span>
      <img className={classes.icon} src={supportIcon} alt="" />
    </div>
  );
};

export default SupportButton;
